import React from 'react';
import { OrganogramDto, organogramDtoInitial } from '../../Models/OrganogramDto';

export interface IOrganogramsContextProps {
    organogramDto: OrganogramDto[],
    setOrganogramDto: (organogramDto: OrganogramDto[]) => void
}

export const OrganogramsContextInitial: IOrganogramsContextProps = {
    organogramDto: [organogramDtoInitial],
    setOrganogramDto: () => { ''; }
};

export const OrganogramsContext = React.createContext(OrganogramsContextInitial);



